import React, { useState } from "react";
import { Button, Modal } from "antd";
import { useDispatch } from "react-redux";
import useOtpHook from "../../../../Hooks/useOtpHook";
import { dispatchtoast, getLocalStorageItem } from "../../../../Utils";
import { EkoDoExpressPay } from "../EkoEndpoint";

const OtpEkoExpressPayout = ({
  isOpen,
  setIsOpen,
  setHide,
  setResponse,
  setXpaymodal,
  setShowSuccess,
  otherFields,
  endpoint,
}) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const { handleChange, handleKeyUp, pin, inputRefs, resetPin } = useOtpHook(4);
  // const handleVerify = () => {
  //     setBtnLoading(true);
  //     let data={...otherFields}
  //     data.bank_id=otherFields.bank_id?.value?otherFields.bank_id?.value:otherFields?.bank_id
  //     const formdata = new FormData();
  //     formdata.append("otp", pin.join(""));

  //     Object.keys(data).map((key) =>
  //       formdata.append(key, data[key])
  //     );
  //     XpressPayout(formdata)
  //       .then((res) => {
  //         if (res) {
  //           if (res.status) {
  //             dispatchtoast("Xpress payout successfull");
  //             setIsOpen(false);
  //             form.resetFields();
  //             setResult({
  //               data: {
  //                 "Benificiary Name": res.data.benificiary_name,
  //                 "Account No.": res.data.account_no,
  //                 Amount: otherFields.amount,
  //                 "Api Transaction Id": res.data.api_transaction_id,
  //                 status:
  //                   res.data.payment_status === 1
  //                     ? "Success"
  //                     : res.data.payment_status === 2
  //                     ? "Failed"
  //                     : "Pending",
  //                 Remark: res.message,
  //               },
  //               transaction_id: res.data.transaction_id,
  //             });
  //             setOpenReceiptDrawer(true);
  //           }
  //         } else {
  //           dispatchtoast("Something went wrong", true);
  //         }
  //       })
  //       .catch((err) => console.log(err))
  //       .finally(() => setBtnLoading(false));
  //   };
  console.log(otherFields, "otherfileds");
  const handleVerify = () => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("pin", pin.join(""));
    formdata.append("remitter_beneficiary_id", otherFields.id);
    formdata.append("benificiary_account", otherFields.account_id);
    formdata.append("benificiary_ifsc", otherFields.ifsc);
    formdata.append("benificiary_name", otherFields.beneficiary);
    formdata.append("bank_id", otherFields.id);
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));
    formdata.append("otp_uid", otherFields?.otp_uid);
    formdata.append("amount", otherFields?.amount);
    formdata.append("payment_purpose", otherFields?.purpose);
    formdata.append("transaction_type", otherFields?.transaction_type);
    formdata.append("remitter_mobile", otherFields?.mobile);
    // console.log("EkoDoExpressPay");
    EkoDoExpressPay(formdata)
      .then((res) => {
        if (res) {
          if (res.status) {
            dispatchtoast(res.message);
            setIsOpen(false);
            setXpaymodal(false);
            setHide(false);
            setResponse(res.data);
            setShowSuccess(true);
          }
        } else {
          setIsOpen(false);
          setXpaymodal(false);
          dispatchtoast("Something went wrong", true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setBtnLoading(false);
        setIsOpen(false);
        setXpaymodal(false);
      });
  };

  return (
    <Modal
      title={"Verify PIN"}
      footer={null}
      className="shadow-normal"
      width={300}
      maskClosable={false}
      open={isOpen}
      onCancel={() => {
        setIsOpen(false);
        setXpaymodal(false);
        resetPin();
      }}
    >
      <div className="  rounded-3xl shadow-normal bg-white p-5">
        <div className="header flex flex-col justify-center items-center">
          <p className="text-[15px] mt-3 text-gray-500">Enter PIN</p>
        </div>
        <div className=" mt-5 flex justify-center items-center">
          {[1, 2, 3, 4].map((i, index) => {
            return (
              <>
                <input
                  key={index}
                  ref={inputRefs[index]}
                  type="text"
                  maxLength={1}
                  className="w-[15px] otpinput xs:w-[35px] sm:w-[35px] md:w-[40px] text-bsblackrgb rounded-md bg-gray-300 h-8  mx-1 border-none focus:outline-none focus:border-none text-center"
                  value={pin[index]}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyUp={(e) => handleKeyUp(index, e)}
                />
              </>
            );
          })}
        </div>
        <Button
          loading={btnLoading}
          onClick={() => pin.length === 4 && handleVerify()}
          className={`SignInBtn w-full ${
            pin.length === 4 ? "cursor-pointer" : "cursor-not-allowed"
          }  mt-4 ${
            pin.length === 4 ? "bg-primary" : "bg-bsgray"
          }  flex justify-center border-none items-center h-12 mt-10 rounded-full text-white text-[12px] font-bold`}
        >
          <p>Verify PIN</p>
        </Button>
      </div>
    </Modal>
  );
};

export default OtpEkoExpressPayout;
